export const SERVICES_HEADERS = {
  IS_ACTIVE: 'isActive',
  COMPONENT: 'component',
  LOGICAL_COMPONENT: 'logicalComponent',
  VARIANT: 'variant',
  SERVICE_TYPE: 'serviceType',
  ZONE: 'zone',
}

export const SERVICES_EVENTS_FORM = {
  ZONE: 'zone',
  SERVICE_ID: 'serviceId',
  EVENT: 'event',
  SERVICE_TYPE: 'serviceType',
}

export const ALL_TYPES_JSON_FILENAME = 'ALL'
